/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthScopes } from './OAuthScopes';
import {
    OAuthScopesFromJSON,
    OAuthScopesFromJSONTyped,
    OAuthScopesToJSON,
    OAuthScopesToJSONTyped,
} from './OAuthScopes';

/**
 * 
 * @export
 * @interface UpdateOAuthClientBody
 */
export interface UpdateOAuthClientBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateOAuthClientBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOAuthClientBody
     */
    logo?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOAuthClientBody
     */
    redirectUris?: Array<string>;
    /**
     * 
     * @type {Array<OAuthScopes>}
     * @memberof UpdateOAuthClientBody
     */
    scopes?: Array<OAuthScopes>;
}

/**
 * Check if a given object implements the UpdateOAuthClientBody interface.
 */
export function instanceOfUpdateOAuthClientBody(value: object): value is UpdateOAuthClientBody {
    return true;
}

export function UpdateOAuthClientBodyFromJSON(json: any): UpdateOAuthClientBody {
    return UpdateOAuthClientBodyFromJSONTyped(json, false);
}

export function UpdateOAuthClientBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOAuthClientBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'redirectUris': json['redirectUris'] == null ? undefined : json['redirectUris'],
        'scopes': json['scopes'] == null ? undefined : ((json['scopes'] as Array<any>).map(OAuthScopesFromJSON)),
    };
}

export function UpdateOAuthClientBodyToJSON(json: any): UpdateOAuthClientBody {
    return UpdateOAuthClientBodyToJSONTyped(json, false);
}

export function UpdateOAuthClientBodyToJSONTyped(value?: UpdateOAuthClientBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'logo': value['logo'],
        'redirectUris': value['redirectUris'],
        'scopes': value['scopes'] == null ? undefined : ((value['scopes'] as Array<any>).map(OAuthScopesToJSON)),
    };
}

